var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_2745_00801"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_2745_00801)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,4C12.55228,4,13,4.447715,13,5C13,5,13,11,13,11C13,11,19,11,19,11C19.552300000000002,11,20,11.44772,20,12C20,12.55228,19.552300000000002,13,19,13C19,13,13,13,13,13C13,13,13,19,13,19C13,19.552300000000002,12.55228,20,12,20C11.44772,20,11,19.552300000000002,11,19C11,19,11,13,11,13C11,13,5,13,5,13C4.447715,13,4,12.55228,4,12C4,11.44772,4.447715,11,5,11C5,11,11,11,11,11C11,11,11,5,11,5C11,4.447715,11.44772,4,12,4C12,4,12,4,12,4Z",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.52091962147cd3785845297efea76227.svg";
export { ForwardRef as ReactComponent };